import { WrapMdMarginBottom } from 'App/global-style';
import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ContentWrapper = styled(WrapMdMarginBottom)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const FormFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
`;
